export function matchesBillingSummaryAccount(summary = null, accountId = "") {
  const normalizedAccountId = String(accountId || "").trim();
  if (!normalizedAccountId || !summary || typeof summary !== "object") {
    return false;
  }

  const summaryAccountId = String(summary.accountId || "").trim();
  const summaryBillingAccountId = String(summary.billingAccountId || "").trim();

  return summaryBillingAccountId === normalizedAccountId
    || summaryAccountId === normalizedAccountId;
}
